import { useMemo } from "react";
import { useProposals } from "./use-connector-updates";
import { isOpenProposalStatus } from "@/lib/pending-update-status";

/**
 * The number on the Health rail item: vendor updates still waiting on this
 * org. The page itself adds broken connections and failing workflows, whose
 * reads are only paid for once the page is open; the rail must stay cheap
 * because it is on every page.
 */
export function useHealthAttentionCount(opts: { enabled: boolean }): { data: number; isPending: boolean } {
  const proposals = useProposals({ scope: "mine", enabled: opts.enabled });
  const data = useMemo(
    () => (proposals.data ?? []).filter((p) => isOpenProposalStatus(p.status)).length,
    [proposals.data],
  );
  return { data, isPending: proposals.isPending };
}
